import { useEffect, useId, useLayoutEffect } from 'react';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import { API_BASE_URL } from '../apiBase';

/** Public surfaces use Office branding without rewriting personal dashboard preferences. */
export default function usePublicAppearance({ enabled = true, loadBranding = true, resetKey } = {}) {
  const scope = useId();
  const appearance = useTheme();
  const { enterPublicSurface, applyPublicBranding } = appearance;
  useLayoutEffect(() => {
    if (!enabled || typeof enterPublicSurface !== 'function') return undefined;
    return enterPublicSurface(scope);
  }, [enabled, scope, enterPublicSurface, resetKey]);
  useEffect(() => {
    if (!enabled || !loadBranding || typeof applyPublicBranding !== 'function') return undefined;
    let active = true;
    axios.get(`${API_BASE_URL}/api/public/branding`).then(({ data }) => {
      if (active && data) applyPublicBranding(data);
    }).catch(() => {});
    return () => { active = false; };
  }, [enabled, loadBranding, applyPublicBranding]);
  return appearance;
}
